/*# sourceMappingURL=news-article.component-R5X7PHJW.css.map */
